<template>
  <div style="padding: 0 20px">
    <!--    <a-row :gutter="24" class="row-box">-->
    <!--      <a-col :span="24" class="title-1 title-margin">校园整体情况</a-col>-->
    <!--      <a-col-->
    <!--        v-for="(item, index) in headCardList"-->
    <!--        :key="index"-->
    <!--        :span="24 / headCardList.length"-->
    <!--        :style="{ marginBottom: '24px' }"-->
    <!--      >-->
    <!--        <a-card-->
    <!--          :loading="loading"-->
    <!--          class="head-card-box"-->
    <!--          :style="{ backgroundColor: item.backgroundColor }"-->
    <!--        >-->
    <!--          <div class="title" style="font-size: 18px; font-weight: bold; margin-bottom: 10px">-->
    <!--            {{ item.title }}-->
    <!--            &lt;!&ndash; <span class="detail-icon" style="color: #009cfa" @click="cardDetail('dynamic')">-->
    <!--              详情-->
    <!--            </span> &ndash;&gt;-->
    <!--          </div>-->
    <!--          <div class="card-content">-->
    <!--            <div v-for="(content, cIndex) in item.contentList" :key="cIndex" class="card-item">-->
    <!--              <CountAnimation class="item-value" :end-val="content.value" />-->
    <!--              <span class="item-desc">{{ content.label }}</span>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </a-card>-->
    <!--      </a-col>-->
    <!--    </a-row>-->
    <a-row :gutter="24" class="row-box" style="margin-top: 20px">
      <template v-for="(item, index) in stuCardList">
        <a-col :span="24" class="flex-between title-margin">
          <div>
            <a-radio-group
              v-if="index == 0"
              v-model="modeType"
              @change="changModeType"
              style="margin-left: auto"
            >
              <a-radio-button value="1">工作预览</a-radio-button>
              <a-radio-button value="2">整体数据概览</a-radio-button>
            </a-radio-group>
          </div>
          <!--<div class="title-1">{{ item.title }}</div>-->
        </a-col>
        <a-col
          v-for="(sItem, index) in item.list"
          :key="index"
          :span="24 / 6"
          style="margin-bottom: 10px"
        >
          <a-card
            class="key-point-item"
            :style="{ backgroundColor: sItem.backgroundColor || '#fff' }"
            @click="cardSkip(sItem)"
          >
            <div
              class="number-value"
              :style="{ color: sItem.backgroundColor ? '#fff' : '#595959' }"
            >
              <CountAnimation :end-val="sItem.value" />
            </div>
            <div :style="{ marginTop: '20px', color: sItem.backgroundColor ? '#fff' : '#595959' }">
              {{ sItem.label }}
            </div>
          </a-card>
        </a-col>
      </template>
      <a-col :span="24">
        <a-divider type="horizontal" style="margin: 15px 0px" />
      </a-col>
      <a-col :span="24" class="title-1 title-margin flex-between">
        <div>我的计划</div>
        <a-button type="primary" style="margin-left: auto" @click="createPlan">新建计划</a-button>
      </a-col>
      <div
        v-if="planList.length"
        class="scroll-container box-shadow-1"
        ref="scrollContainer"
        @scroll="handleScroll"
      >
        <a-col v-for="(item, index) in planList" :key="index" :span="12" class="plan-card">
          <a-card style="border-radius: 5px; padding: 0 10px">
            <div class="plan-card-content">
              <div>
                <div>
                  <span class="title" style="margin-right: 10px">{{ item.title }}</span>
                  <a-tag :color="item.color">
                    {{ getDictCodeData(item.status) }}
                  </a-tag>
                  <a-tag :color="['orange', 'blue'][item.tag]">
                    {{ ['测评', '活动'][item.tag] }}
                  </a-tag>
                  <!-- 管理员和非管理员自己创建且不为进行中的可删除-->
                  <span
                    v-show="
                      userInfo().username == 'admin' ||
                      (userInfo().username == item.createBy && item.status != 1)
                    "
                    class="action-icon transparent-area-appear"
                  >
                    <a-icon
                      type="edit"
                      :style="{ fontSize: '18px', color: '#1783E8', marginRight: '10px' }"
                      @click.stop="editCard(item)"
                    />
                    <a-popconfirm title="是否删除该卡片？" @confirm="deleteCard(item)">
                      <a-icon
                        type="delete"
                        :style="{ fontSize: '18px', color: '#FF4D4F' }"
                        @click.stop="() => {}"
                      />
                    </a-popconfirm>
                  </span>
                </div>
                <div style="margin-top: 10px">
                  活动日期:
                  <span v-if="item.beginDate && item.endDate">
                    {{ item.beginDate }} 至 {{ item.endDate }}
                  </span>
                  <span v-else>无</span>
                </div>
                <a-button
                  type="primary"
                  style="margin-top: 10px"
                  @click="$emit('showPlanDetail', item)"
                >
                  查看详情
                </a-button>
              </div>
              <a-progress type="circle" :strokeColor="item.color" :percent="item.rate">
                <template #format="percent">
                  <div>
                    <div style="font-size: 24px; font-weight: bold">{{ percent }}%</div>
                    <div style="margin-top: 10px">班级参与率</div>
                  </div>
                </template>
              </a-progress>
            </div>
          </a-card>
        </a-col>
      </div>
      <a-col v-else :span="24">
        <EmptyData :loading="loading" :styleObj="{ padding: '20px 0px' }" />
      </a-col>
    </a-row>
    <CreatePlan ref="createPlanRef" @refreshData="refreshData" />
    <CreateCourseModal ref="createCourseModalRef" />
  </div>
</template>

<script>
import CountAnimation from '@/components/CountAnimation'
import CreatePlan from '@/comUi/CreatePlan'
import { deleteAction, getAction } from '@api/manage'
import { getDictCodeData } from '@/utils/util'
import CreateCourseModal from '@/comUi/SchemeCard/components/CreateCourseModal'
import { mapGetters } from 'vuex'

export default {
  name: 'WorkOverview',
  components: {
    CountAnimation,
    CreatePlan,
    CreateCourseModal,
  },
  props: {
    modeType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      queryParam: {},
      loading: true,
      pageNo: 1,
      pageSize: 5,
      headCardList: [
        {
          title: '今日校园动态',
          backgroundColor: '#009cfa',
          contentList: [
            {
              label: '心情提醒',
              value: 0,
            },
            {
              label: '班级提醒',
              value: 0,
            },
            {
              label: '心情记录',
              value: 0,
            },
          ],
        },
        {
          title: '今日校园心情',
          backgroundColor: '#23cdad',
          contentList: [
            {
              label: '正常人数',
              value: 0,
            },
            {
              label: '提醒人数',
              value: 0,
            },
            {
              label: '关爱人数',
              value: 0,
            },
          ],
        },
        {
          title: '学校基本信息',
          backgroundColor: '#725be9',
          contentList: [
            {
              label: '学生人数',
              value: 0,
            },
            {
              label: '心理老师访问次数',
              value: 0,
            },
            {
              label: '教师访问次数',
              value: 0,
            },
          ],
        },
      ],
      // 重点关爱学生/小叮当提醒学生
      stuCardList: [
        {
          title: '重点关爱学生',
          list: [
            {
              value: 0,
              key: 'careListCnt',
              label: '重点关爱学生数',
              backgroundColor: '#F66860',
              path: '/school/mentalHealth/CrisisIntervent',
            },
            {
              value: 0,
              key: 'pgCnt',
              label: '待评估学生数',
              path: '/school/mentalHealth/MindAssessment',
            },
            {
              value: 0,
              key: 'dwigyCnt',
              label: '待危机干预学生数',
              path: '/school/mentalHealth/CrisisIntervent',
            },
            {
              value: 0,
              key: 'txFdyyCnt',
              label: '心理辅导预约',
              backgroundColor: '#1783E8',
              path: '/school/mentalHealth/PsychologicalCounseling',
              query: {
                type: 7,
              },
            },
            {
              value: 0,
              key: 'txYfdCnt',
              label: '已辅导学生数',
              path: '/school/mentalHealth/PsychologicalCounseling',
              query: {
                type: 8,
              },
            },
          ],
        },
      ],
      planList: [],
    }
  },
  created() {
    this.getHeadCardData()
    this.getWordView()
    this.getPlanList()
  },
  methods: {
    ...mapGetters(['userInfo']),
    getHeadCardData() {
      // 校园动态
      getAction('/statistic/todaySchoolDynamic').then((res) => {
        if (res.success) {
          const { mood_warn, class_warn, mood_records } = res.result
          const contentList = [
            {
              label: '心情提醒',
              value: mood_warn || 0,
            },
            {
              label: '班级提醒',
              value: class_warn || 0,
            },
            {
              label: '心情记录',
              value: mood_records || 0,
            },
          ]
          this.$set(this.headCardList[0], 'contentList', contentList)
        }
      })
      // 校园心情
      getAction('/statistic/todaySchoolMood', this.queryParam).then((res) => {
        if (res.success) {
          const { normalPeople, needCarePeople, carePeople } = res.result
          const contentList = [
            {
              label: '正常人数',
              value: normalPeople || 0,
            },
            {
              label: '提醒人数',
              value: needCarePeople || 0,
            },
            {
              label: '关爱人数',
              value: carePeople || 0,
            },
          ]
          this.$set(this.headCardList[1], 'contentList', contentList)
        }
      })
      // 学校基本信息
      getAction('/statistic/schoolBasicInfo', this.queryParam).then((res) => {
        if (res.success) {
          const { studentCount, teacherCount, parentVisitAvg } = res.result
          const contentList = [
            {
              label: '学生人数',
              value: studentCount || 0,
            },
            {
              label: '心理老师访问次数',
              value: parentVisitAvg || 0,
            },
            {
              label: '教师访问次数',
              value: teacherCount || 0,
            },
          ]
          this.$set(this.headCardList[2], 'contentList', contentList)
        }
      })
    },
    getWordView() {
      getAction('/home/psychologyTeacherWorkbench').then((res) => {
        if (res.success) {
          const keys = Object.keys(res.result)
          if (!keys.length) return
          keys.forEach((key) => {
            const item = res.result[key]
            const index = this.stuCardList[0].list.findIndex((i) => {
              return i.key == key
            })
            if (index == -1) return
            this.$set(this.stuCardList[0].list[index], 'value', item)
            // console.log('数值数据：', this.stuCardList[0].list)
          })

          console.log('工作概况', res.result)
        }
      })
    },
    getPlanList() {
      this.loading = true
      getAction('/schoolEvaluationPlan/list', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          const planList = res.result.records.map((item) => {
            const rate = (item.finishClassNum / item.planClassNum) * 100
            return {
              ...item,
              id: item.id,
              title: item.name,
              status: item.status,
              time: item.createTime,
              rate: rate && rate.toFixed(1),
              color: '#1783E8',
              tag: 0, // tag: 0 代表测评，1 代表活动
            }
          })
          this.planList.push(...planList)
        }
      })
      getAction('/schoolActivityPlan/list', { pageNo: this.pageNo, pageSize: this.pageSize }).then(
        (res) => {
          if (res.success) {
            const activityPlanList = res.result.records.map((item) => {
              const rate = (item.finishClassNum / item.planClassNum) * 100
              return {
                ...item,
                id: item.id,
                title: item.title,
                status: item.status,
                time: item.createTime,
                rate: rate && rate.toFixed(1),
                color: '#1783E8',
                tag: 1,
              }
            })
            this.planList.push(...activityPlanList)
            setTimeout(() => {
              this.loading = false
            }, 500)
          }
        }
      )
      console.log('计划列表：', this.planList)
    },
    refreshData(data) {
      console.log('刷新数据：', data)
      // 新增
      if (!data.id) {
        this.pageNo = 1
        this.planList = []
        this.getPlanList()
        return
      }
      // 编辑
      const findIndex = this.planList.findIndex((pItem) => pItem.id === data.id)
      console.log('findIndex', findIndex)
      if (findIndex === -1) return
      this.$set(this.planList, findIndex, {
        ...data,
        title: data.name,
      })
      console.log('计划列表：', this.planList)
    },
    getDictCodeData(status) {
      return getDictCodeData('assessment_status', status).text || ''
    },
    changModeType() {
      this.$emit('changeModeType', this.modeType)
    },
    createPlan() {
      this.$refs.createPlanRef.showModal()
      // this.$refs.createCourseModalRef.showModal()
    },
    cardSkip(item) {
      if (!item?.path) return
      this.$router.push({
        path: item.path,
        query: item.query || {},
      })
    },
    handleScroll() {
      const container = this.$refs.scrollContainer
      // 检查是否滚动到底部
      if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
        this.pageNo += 1
        this.getPlanList()
      }
    },
    async deleteCard(item) {
      const findIndex = this.planList.findIndex((pItem) => pItem.id === item.id)
      console.log('findIndex', findIndex)
      if (findIndex === -1) return
      const urlArr = ['/schoolEvaluationPlan', '/schoolActivityPlan']
      const res = await deleteAction(`${urlArr[item.tag]}/delete`, { id: item.id })
      if (res.success) {
        this.$message.success(res.message)
        this.planList.splice(findIndex, 1)
        return
      }
      this.$message.error(res.message)
    },
    editCard(item) {
      console.log('编辑信息：', item)
      this.$refs.createPlanRef.showModal(item)
    },
  },
}
</script>
<style scoped lang="less">
.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.head-card-box {
  min-height: 135px;
  color: #fff;
  border-radius: 15px;
  padding: 0px 20px;
}

.row-box {
  padding: 10px !important;
  padding-bottom: 0 !important;
  border-radius: 10px;
  background-color: #fff;
}

.title-margin {
  margin-top: 10px;
  margin-bottom: 15px;
}

.card-content {
  display: flex;
  justify-content: space-between;

  .card-item {
    // flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    .item-value {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 2px;
    }

    .item-desc {
      font-size: 14px;
    }
  }
}

.key-point-item {
  height: 140px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  cursor: pointer;
}

.number-value {
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  border-radius: 5px;
}

.plan-card {
  margin-bottom: 20px;

  /deep/ .ant-card-body {
    padding: 12px;
  }

  .plan-card-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.scroll-container {
  height: 512px; /* 设置一个固定高度 */
  padding: 20px 10px;
  border-radius: 8px;
  overflow: hidden;
  overflow-y: scroll; /* 启用垂直滚动 */
}
</style>
